import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Exercicio } from '../models/exercicio';

@Injectable({
  providedIn: 'root'
})
export class ExercicioService {

  private api = '/api/exercicio';

  constructor(private http: HttpClient) { }

  // =====================
  // READ (User/Admin)
  // =====================
  getAll(): Observable<Exercicio[]> {
    return this.http.get<Exercicio[]>(this.api);
  }

  getById(id: number): Observable<Exercicio> {
    return this.http.get<Exercicio>(`${this.api}/${id}`);
  }

  // =====================
  // WRITE (Admin only no backend)
  // =====================
  create(model: Exercicio): Observable<Exercicio> {
    return this.http.post<Exercicio>(this.api, model);
  }

  update(model: Exercicio): Observable<void> {
    return this.http.put<void>(`${this.api}/${model.id}`, model);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  uploadImagem(exercicioId: number, file: File) {
  const formData = new FormData();
  formData.append('file', file);

  return this.http.post(`${this.api}/${exercicioId}/imagens`, formData);
}

getImagens(exercicioId: number) {
  return this.http.get<any[]>(`${this.api}/${exercicioId}/imagens`);
}

deleteImagem(id: number) {
  return this.http.delete(`${this.api}/imagens/${id}`);
}
}